module.exports = __webpack_public_path__ + "img/ds.508cf072.png";